import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule} from '@angular/http';
//import { Facebook } from '@ionic-native/facebook';
//import { Ionic2MaskDirective } from "ionic2-mask-directive";
import { AppVersion } from '@ionic-native/app-version';
//import { OneSignal } from '@ionic-native/onesignal';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CardIO } from '@ionic-native/card-io';

import { FullCalendarModule } from 'ng-fullcalendar';
//import { IonicStepperModule } from 'ionic-stepper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';

import { LoginPage } from '../pages/login/login';
import { PreloginPage } from '../pages/prelogin/prelogin';
import { RegisterPage } from '../pages/register/register';
import { RegisterTermsPage } from '../pages/register-terms/register-terms';
import { ChangePasswordPage } from '../pages/change-password/change-password';

import { BusinessMainPage } from '../pages/business-main/business-main';
import { ConsumerMainPage } from '../pages/consumer-main/consumer-main';
import { StamperMainPage } from '../pages/stamper-main/stamper-main';
import { CashierMainPage } from '../pages/cashier-main/cashier-main';
import { ExpeditorMainPage } from '../pages/expeditor-main/expeditor-main';
import { CustomSplashPage } from '../pages/custom-splash/custom-splash';

import { DownloadLatestVersionPage } from '../pages/download-latest-version/download-latest-version';
import { RichTextEditorPage } from '../pages/rich-text-editor/rich-text-editor';

import { BusinessQrcodeScannerPage } from '../pages/business-qrcode-scanner/business-qrcode-scanner';
import { BusinessCategoryFilterPage } from '../pages/business-category-filter/business-category-filter';
import { BusinessDetailPage } from '../pages/business-detail/business-detail';
import { BusinessPunchCardListPage } from '../pages/business-punch-card-list/business-punch-card-list';
import { BusinessPunchCardManagerPage } from '../pages/business-punch-card-manager/business-punch-card-manager';
import { BusinessPunchCardSequenceManagerPage } from '../pages/business-punch-card-sequence-manager/business-punch-card-sequence-manager';
import { BusinessPunchCardRedeemPage } from '../pages/business-punch-card-redeem/business-punch-card-redeem';
import { BusinessOfferListPage } from '../pages/business-offer-list/business-offer-list';
import { BusinessOfferManagerPage } from '../pages/business-offer-manager/business-offer-manager';
import { BusinessOfferRedeemPage } from '../pages/business-offer-redeem/business-offer-redeem';
import { BusinessRewardRedeemPage } from '../pages/business-reward-redeem/business-reward-redeem';
import { BusinessSiteQrPage } from '../pages/business-site-qr/business-site-qr';
import { BusinessRegisterPage } from '../pages/business-register/business-register';
import { BusinessUserListPage } from '../pages/business-user-list/business-user-list';
import { BusinessUserManagementPage } from '../pages/business-user-management/business-user-management';
import { BusinessPunchCardIconSelectPage } from '../pages/business-punch-card-icon-select/business-punch-card-icon-select';
import { BusinessSpecialtyListPage } from '../pages/business-specialty-list/business-specialty-list';
import { BusinessSpecialtyManagerPage } from '../pages/business-specialty-manager/business-specialty-manager';
import { BusinessDashboardPage } from '../pages/business-dashboard/business-dashboard';
import { BusinessInvoiceMainPage } from '../pages/business-invoice-main/business-invoice-main';
import { BusinessInvoiceSearchPage } from '../pages/business-invoice-search/business-invoice-search';
import { BusinessUserInvoiceListPage } from '../pages/business-user-invoice-list/business-user-invoice-list';
import { BusinessUserInvoiceDetailPage } from '../pages/business-user-invoice-detail/business-user-invoice-detail';
import { BusinessInvoiceListPage } from '../pages/business-invoice-list/business-invoice-list';
import { BusinessInvoiceDetailPage } from '../pages/business-invoice-detail/business-invoice-detail';
import { BusinessRichTextEditorPage } from '../pages/business-rich-text-editor/business-rich-text-editor';
import { BusinessMessagingMainPage } from '../pages/business-messaging-main/business-messaging-main';
import { BusinessMessageManagerPage } from '../pages/business-message-manager/business-message-manager';
import { BusinessMessageLogListPage } from '../pages/business-message-log-list/business-message-log-list';
import { BusinessMessageDetailImagePage } from '../pages/business-message-detail-image/business-message-detail-image';
import { BusinessPunchCardMainPage } from '../pages/business-punch-card-main/business-punch-card-main';
import { BusinessUserPunchCardListPage } from '../pages/business-user-punch-card-list/business-user-punch-card-list';
import { BusinessUserPunchCardDetailPage } from '../pages/business-user-punch-card-detail/business-user-punch-card-detail';
import { BusinessProductListPage } from '../pages/business-product-list/business-product-list';
import { BusinessProductManagerPage } from '../pages/business-product-manager/business-product-manager';
import { BusinessProductDetailPage } from '../pages/business-product-detail/business-product-detail';
import { BusinessProductPaymentListPage } from '../pages/business-product-payment-list/business-product-payment-list';
import { BusinessProductPaymentManagerPage } from '../pages/business-product-payment-manager/business-product-payment-manager';
import { BusinessProductPaymentDetailPage } from '../pages/business-product-payment-detail/business-product-payment-detail';
import { BusinessProductPaymentMainPage } from '../pages/business-product-payment-main/business-product-payment-main';
import { BusinessProductPaymentCheckoutPage } from '../pages/business-product-payment-checkout/business-product-payment-checkout';
import { BusinessProductSearchPage } from '../pages/business-product-search/business-product-search';
import { BusinessProductCategoryListPage } from '../pages/business-product-category-list/business-product-category-list';
import { BusinessProductCategoryManagerPage } from '../pages/business-product-category-manager/business-product-category-manager';
import { BusinessProductSubcategoryListPage } from '../pages/business-product-subcategory-list/business-product-subcategory-list';
import { BusinessProductSubcategoryManagerPage } from '../pages/business-product-subcategory-manager/business-product-subcategory-manager';
import { BusinessProductCategoryPage } from '../pages/business-product-category/business-product-category';
import { BusinessProductPaymentInvoiceListPage } from '../pages/business-product-payment-invoice-list/business-product-payment-invoice-list';
import { BusinessProductPaymentInvoiceDetailPage } from '../pages/business-product-payment-invoice-detail/business-product-payment-invoice-detail';
import { BusinessUserOrderListPage } from '../pages/business-user-order-list/business-user-order-list';
import { BusinessProductSubcategoryModifierListPage } from '../pages/business-product-subcategory-modifier-list/business-product-subcategory-modifier-list';
import { BusinessProductSubcategoryModifierManagerPage } from '../pages/business-product-subcategory-modifier-manager/business-product-subcategory-modifier-manager';
import { BusinessProductPaymentModifierListPage } from '../pages/business-product-payment-modifier-list/business-product-payment-modifier-list';
import { BusinessModifierGroupListPage } from '../pages/business-modifier-group-list/business-modifier-group-list';
import { BusinessModifierGroupManagerPage } from '../pages/business-modifier-group-manager/business-modifier-group-manager';
import { BusinessProductSubcategoryModifierGroupListPage } from '../pages/business-product-subcategory-modifier-group-list/business-product-subcategory-modifier-group-list';
import { BusinessProductPaymentVoidManagerPage } from '../pages/business-product-payment-void-manager/business-product-payment-void-manager';

import { BusinessProductExpediterInvoiceListPage } from '../pages/business-product-expediter-invoice-list/business-product-expediter-invoice-list';
import { BusinessProductExpediterInvoiceDetailPage } from '../pages/business-product-expediter-invoice-detail/business-product-expediter-invoice-detail';

import { ConsumerNearbyPage } from '../pages/consumer-nearby/consumer-nearby';
import { ConsumerBusinessListPage } from '../pages/consumer-business-list/consumer-business-list';
import { ConsumerBusinessDetailPage } from '../pages/consumer-business-detail/consumer-business-detail';
import { ConsumerBusinessMainPage } from '../pages/consumer-business-main/consumer-business-main';
import { ConsumerRedeemablesMainPage } from '../pages/consumer-redeemables-main/consumer-redeemables-main';
import { ConsumerPinsPage } from '../pages/consumer-pins/consumer-pins';
import { ConsumerProfilePage } from '../pages/consumer-profile/consumer-profile';
import { ConsumerRewardListPage } from '../pages/consumer-reward-list/consumer-reward-list';
import { ConsumerRewardDetailPage } from '../pages/consumer-reward-detail/consumer-reward-detail';
import { ConsumerRewardBuyPage } from '../pages/consumer-reward-buy/consumer-reward-buy';
import { ConsumerRewardSharePage } from '../pages/consumer-reward-share/consumer-reward-share';
import { ConsumerPunchCardManagerPage } from '../pages/consumer-punch-card-manager/consumer-punch-card-manager';
import { ConsumerOfferMainPage } from '../pages/consumer-offer-main/consumer-offer-main';
import { ConsumerOfferManagerPage } from '../pages/consumer-offer-manager/consumer-offer-manager';
import { ConsumerOfferListPage } from '../pages/consumer-offer-list/consumer-offer-list';
import { ConsumerOfferUserListPage } from '../pages/consumer-offer-user-list/consumer-offer-user-list';
import { ConsumerOfferDetailPage } from '../pages/consumer-offer-detail/consumer-offer-detail';
import { ConsumerOfferUserDetailPage } from '../pages/consumer-offer-user-detail/consumer-offer-user-detail';
import { ConsumerPunchCardQrPage } from '../pages/consumer-punch-card-qr/consumer-punch-card-qr';
import { ConsumerPunchCardTermsPage } from '../pages/consumer-punch-card-terms/consumer-punch-card-terms';
import { ConsumerMessageTimelinePage } from '../pages/consumer-message-timeline/consumer-message-timeline';
import { ConsumerMessageDetailPage } from '../pages/consumer-message-detail/consumer-message-detail';
import { ConsumerCheckoutPage } from '../pages/consumer-checkout/consumer-checkout';
import { CustomerRewardGainedPage } from '../pages/customer-reward-gained/customer-reward-gained';
import { ConsumerProfileMainPage } from '../pages/consumer-profile-main/consumer-profile-main';
import { ConsumerOfferMultiStatusPage } from '../pages/consumer-offer-multi-status/consumer-offer-multi-status';
import { ConsumerBusinessOfferListPage } from '../pages/consumer-business-offer-list/consumer-business-offer-list';
import { ConsumerBusinessPunchCardListPage } from '../pages/consumer-business-punch-card-list/consumer-business-punch-card-list';
import { ConsumerBusinessTimelinePage } from '../pages/consumer-business-timeline/consumer-business-timeline';

import { ConsumerMoneyMainOrderListPage } from '../pages/consumer-money-main-order-list/consumer-money-main-order-list';


import { ConsumerMoneyOrderDetailPage } from '../pages/consumer-money-order-detail/consumer-money-order-detail';

import { ConsumerAddMoneyPage } from '../pages/consumer-add-money/consumer-add-money';
import { ConsumerMoneyAddDevicePage } from '../pages/consumer-money-add-device/consumer-money-add-device';
import { ConsumerProductPaymentManagerPage } from '../pages/consumer-product-payment-manager/consumer-product-payment-manager';

import { PaymentMethodManagementPage } from '../pages/payment-method-management/payment-method-management';
import { PaymentMethodListPage } from '../pages/payment-method-list/payment-method-list';
import { PaymentMethodSelectPage } from '../pages/payment-method-select/payment-method-select';

import { DefaultLoadingPage } from '../pages/default-loading/default-loading';

import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Utils } from '../helpers/utils';
import { IonicStorageModule } from '@ionic/storage';
import { Geolocation } from '@ionic-native/geolocation';
import { LaunchNavigator } from '@ionic-native/launch-navigator';

import { AuthProvider } from '../providers/auth';

import { ConsumerBondHandler } from '../providers/consumer-bond-handler';
import { PaymentMethodHandler } from '../providers/payment-method-handler';
import { BusinessRedeemHandler } from '../providers/business-redeem-handler';
import { ConsumerBondRedeemHandlerProvider } from '../providers/consumer-bond-redeem-handler';
import { BondManagerHandler } from '../providers/bond-manager-handler';
import { BusinessManagerHandler } from '../providers/business-manager-handler';
import { QrCodeHandler } from '../providers/qrcode-handler'

import { Camera } from '@ionic-native/camera';

import { HeaderBlockComponent } from '../components/header-block/header-block';
import { ConsumerPointsHandlerProvider } from '../providers/consumer-points-handler';
import { ConsumerBusinessHandlerProvider } from '../providers/consumer-business-handler';
import { BusinessCardComponent } from '../components/business-card/business-card';
import { UserCardComponent } from '../components/user-card/user-card';
import { ConsumerRewardCardComponent } from '../components/consumer-reward-card/consumer-reward-card';
import { ConsumerCardComponent } from '../components/consumer-card/consumer-card';
import { BusinessMessageBlockComponent } from '../components/business-message-block/business-message-block';
import { ConsumerMessageBlockComponent } from '../components/consumer-message-block/consumer-message-block';
import { BusinessMessageStatusComponent } from '../components/business-message-status/business-message-status';
import { CreditCardComponent } from '../components/credit-card/credit-card';
import { MultiRedeemComponent } from '../components/multi-redeem/multi-redeem';
import { BusinessProductInvoiceDetailSingleComponent } from '../components/business-product-invoice-detail-single/business-product-invoice-detail-single';


import { ConsumerDeviceListComponent } from '../components/consumer-device-list/consumer-device-list';
import { ConsumerMoneyCreditListComponent } from '../components/consumer-money-credit-list/consumer-money-credit-list';
import { ConsumerMoneyDebitListComponent } from '../components/consumer-money-debit-list/consumer-money-debit-list';
import { ConsumerMoneyOrderListComponent } from '../components/consumer-money-order-list/consumer-money-order-list';


import { ConsumerHandlerProvider } from '../providers/consumer-handler';
import { BusinessPunchCardManagerHandler } from '../providers/business-punch-card-handler';
import { BusinessPunchCardSequenceManagerHandler } from '../providers/business-punch-card-sequence-handler';
import { BusinessPunchCardUserRewardManagerHandler } from '../providers/business-punch-card-user-reward-handler';
import { BusinessOfferManagerHandler } from '../providers/business-offer-handler';
import { BusinessSpecialtyManagerHandler } from '../providers/business-specialty-handler';
import { BusinessUserOfferManagerHandler } from '../providers/business-user-offer-handler';
import { ConsumerRewardHandlerProvider } from '../providers/consumer-reward-handler';
import { ConsumerPunchCardHandler } from '../providers/consumer-punch-card-handler';
import { ConsumerOfferManagerHandler } from '../providers/consumer-offer-handler';
import { ConsumerPrepayAmountManagerHandler } from '../providers/consumer-prepay-amount-handler';
import { CustomSplashHandlerProvider } from '../providers/custom-splash-handler';
import { BusinessUserProvider } from '../providers/business-user';
import { BusinessUserInvoiceProvider } from '../providers/business-user-invoice-handler';
import { BusinessProductManagerHandler } from '../providers/business-product-handler';
import { BusinessProductPaymentManagerHandler } from '../providers/business-product-payment-handler';
import { BusinessProductInvoiceHandler } from '../providers/business-product-invoice-handler';
import { BusinessProductCategoryManagerHandler } from '../providers/business-product-category-handler';
import { BusinessProductSubCategoryManagerHandler } from '../providers/business-product-subcategory-handler';
import { BusinessProductSubCategoryModifierManagerHandler } from '../providers/business-product-subcategory-modifier-handler';
import { BusinessModifierGroupManagerHandler } from '../providers/business-modifier-group-handler';
import { ProductPaymentCheckoutHandler } from '../providers/product-payment-checkout-handler';

import { FormatDatePipe } from '../pipes/format-date/format-date';
import { EscapeHtmlPipe } from '../pipes/escape-html';
import { TextMaskModule } from 'angular2-text-mask';
import { PunchCardIconProvider } from '../providers/punch-card-icon';
import { PushNotificationHandlerProvider } from '../providers/push-notification-handler';
import { BusinessMessageProvider } from '../providers/business-message-handler';
import { ConsumerTimelineProvider } from '../providers/consumer-timeline-handler';
import { ConsumerBusinessTimelineProvider } from '../providers/consumer-business-timeline-handler';
import { RichTextEditorProvider } from '../providers/rich-text-editor';
import { BusinessDashboardProvider } from '../providers/business-dashboard';
import { ConsumerCheckoutHandler } from '../providers/consumer-checkout-handler';
import { BusinessInvoiceHandler } from '../providers/business-invoice-handler';
import { PurchaseHandlerProvider } from '../providers/purchase-handler';
import { ConsumerBusinessMainHandlerProvider } from '../providers/consumer-business-main-handler';

import { ConsumerServiceHandlerProvider } from '../providers/consumer-service-handler';
import { CalendarHandlerProvider } from '../providers/calendar-handler';
import { ConsumerMoneyProvider } from '../providers/consumer-money-handler';
import { ConsumerMoneyDeviceProvider } from '../providers/consumer-money-device';

import { ConsumerMoneyOrderHandlerProvider } from '../providers/consumer-money-order-handler';
import { BusinessProductExpeditorHandlerProvider } from '../providers/business-product-expeditor-handler';

@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    ContactPage,

    LoginPage,
    PreloginPage,
    RegisterPage,
    RegisterTermsPage,

    BusinessMainPage,
    ConsumerMainPage,
    StamperMainPage,
    CashierMainPage,
    ExpeditorMainPage,
    CustomSplashPage,
    DownloadLatestVersionPage,
    ChangePasswordPage,
    RichTextEditorPage,

    BusinessQrcodeScannerPage,
    BusinessCategoryFilterPage,
    BusinessDetailPage,
    BusinessPunchCardListPage,
    BusinessPunchCardManagerPage,
    BusinessPunchCardSequenceManagerPage,
    BusinessPunchCardRedeemPage,
    BusinessOfferListPage,
    BusinessOfferManagerPage,
    BusinessOfferRedeemPage,
    BusinessRewardRedeemPage,
    BusinessSiteQrPage,
    BusinessRegisterPage,
    BusinessUserListPage,
    BusinessUserManagementPage,
    BusinessPunchCardIconSelectPage,
    BusinessSpecialtyListPage,
    BusinessSpecialtyManagerPage,
    BusinessDashboardPage,
    BusinessInvoiceListPage,
    BusinessInvoiceDetailPage,
    BusinessInvoiceMainPage, 
    BusinessInvoiceSearchPage,
    BusinessUserInvoiceListPage,
    BusinessUserInvoiceDetailPage,
    BusinessRichTextEditorPage,
    BusinessMessagingMainPage,
    BusinessMessageManagerPage,
    BusinessMessageLogListPage,
    BusinessMessageDetailImagePage,
    BusinessPunchCardMainPage,
    BusinessUserPunchCardListPage,
    BusinessUserPunchCardDetailPage,
    BusinessProductListPage,
    BusinessProductManagerPage,
    BusinessProductDetailPage,
    BusinessProductPaymentListPage,
    BusinessProductPaymentManagerPage,
    BusinessProductPaymentDetailPage,
    BusinessProductPaymentMainPage,
    BusinessProductPaymentCheckoutPage,
    BusinessProductSearchPage,
    BusinessProductCategoryListPage,
    BusinessProductCategoryManagerPage,
    BusinessProductSubcategoryListPage,
    BusinessProductSubcategoryManagerPage,
    BusinessProductCategoryPage,
    BusinessProductPaymentInvoiceListPage, 
    BusinessProductPaymentInvoiceDetailPage,
    BusinessUserOrderListPage,
    BusinessProductSubcategoryModifierListPage, 
    BusinessProductSubcategoryModifierManagerPage, 
    BusinessProductPaymentModifierListPage,
    BusinessModifierGroupListPage, 
    BusinessModifierGroupManagerPage,
    BusinessProductSubcategoryModifierGroupListPage,
    BusinessProductPaymentVoidManagerPage,
    BusinessProductExpediterInvoiceListPage,
    BusinessProductExpediterInvoiceDetailPage,

    ConsumerNearbyPage,
    ConsumerBusinessListPage,
    ConsumerBusinessDetailPage,
    ConsumerBusinessMainPage,
    ConsumerRedeemablesMainPage,
    ConsumerPinsPage,
    ConsumerProfilePage,
    ConsumerRewardListPage,
    ConsumerRewardDetailPage,
    ConsumerRewardSharePage,
    ConsumerRewardBuyPage,
    ConsumerPunchCardManagerPage,
    ConsumerMainPage,
    ConsumerOfferMainPage,
    ConsumerOfferManagerPage,
    ConsumerOfferListPage,
    ConsumerOfferDetailPage,
    ConsumerOfferUserListPage,
    ConsumerOfferUserDetailPage,
    ConsumerCheckoutPage,
    ConsumerPunchCardQrPage,
    ConsumerPunchCardTermsPage,
    ConsumerMessageTimelinePage,
    ConsumerMessageDetailPage,
    ConsumerProfileMainPage,
    CustomerRewardGainedPage,
    ConsumerOfferMultiStatusPage,
    ConsumerBusinessOfferListPage, 
    ConsumerBusinessPunchCardListPage, 
    ConsumerBusinessTimelinePage,
    ConsumerMoneyOrderDetailPage,
    ConsumerMoneyMainOrderListPage,

    ConsumerAddMoneyPage,
    ConsumerMoneyAddDevicePage,
    ConsumerProductPaymentManagerPage,

    PaymentMethodManagementPage,
    PaymentMethodListPage,
    PaymentMethodSelectPage,

    DefaultLoadingPage,

    HeaderBlockComponent,
    BusinessCardComponent,
    UserCardComponent,
    ConsumerRewardCardComponent,
    ConsumerCardComponent,
    BusinessMessageBlockComponent,
    ConsumerMessageBlockComponent,
    BusinessMessageStatusComponent,
    CreditCardComponent,
    MultiRedeemComponent,
    BusinessProductInvoiceDetailSingleComponent,
    
    ConsumerDeviceListComponent,
    ConsumerMoneyCreditListComponent,
    ConsumerMoneyDebitListComponent,
    ConsumerMoneyOrderListComponent,
    
    EscapeHtmlPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    HttpModule,
    FullCalendarModule,
    //IonicStepperModule,
    
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    TextMaskModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    ContactPage,   

    LoginPage,
    PreloginPage,
    RegisterPage,
    RegisterTermsPage,
    ChangePasswordPage,
    RichTextEditorPage,

    BusinessMainPage,
    ConsumerMainPage,
    StamperMainPage,
    CashierMainPage,
    ExpeditorMainPage,
    CustomSplashPage,
    DownloadLatestVersionPage,
    
    BusinessQrcodeScannerPage,
    BusinessCategoryFilterPage,
    BusinessDetailPage,
    BusinessPunchCardListPage,
    BusinessPunchCardManagerPage,
    BusinessPunchCardSequenceManagerPage,
    BusinessPunchCardRedeemPage,
    BusinessOfferListPage,
    BusinessOfferManagerPage,
    BusinessOfferRedeemPage,
    BusinessRewardRedeemPage,
    BusinessSiteQrPage,
    BusinessRegisterPage,
    BusinessUserListPage,
    BusinessUserManagementPage,
    BusinessPunchCardIconSelectPage,
    BusinessSpecialtyListPage,
    BusinessSpecialtyManagerPage,
    BusinessDashboardPage,
    BusinessInvoiceListPage,
    BusinessInvoiceDetailPage,
    BusinessInvoiceMainPage, 
    BusinessInvoiceSearchPage,
    BusinessUserInvoiceListPage,
    BusinessUserInvoiceDetailPage,
    BusinessRichTextEditorPage,
    BusinessMessagingMainPage,
    BusinessMessageManagerPage,
    BusinessMessageLogListPage,
    BusinessMessageDetailImagePage,
    BusinessPunchCardMainPage,
    BusinessUserPunchCardListPage,
    BusinessUserPunchCardDetailPage,
    BusinessProductListPage,
    BusinessProductManagerPage,
    BusinessProductDetailPage,
    BusinessProductPaymentListPage,
    BusinessProductPaymentManagerPage,
    BusinessProductPaymentDetailPage,
    BusinessProductPaymentMainPage,
    BusinessProductPaymentCheckoutPage,
    BusinessProductSearchPage,
    BusinessProductCategoryListPage,
    BusinessProductCategoryManagerPage,
    BusinessProductSubcategoryListPage,
    BusinessProductSubcategoryManagerPage,
    BusinessProductCategoryPage,
    BusinessProductPaymentInvoiceListPage, 
    BusinessProductPaymentInvoiceDetailPage,
    BusinessUserOrderListPage,
    BusinessProductSubcategoryModifierListPage, 
    BusinessProductSubcategoryModifierManagerPage, 
    BusinessProductPaymentModifierListPage,
    BusinessModifierGroupListPage, 
    BusinessModifierGroupManagerPage,
    BusinessProductSubcategoryModifierGroupListPage,
    BusinessProductPaymentVoidManagerPage,
    BusinessProductExpediterInvoiceListPage,
    BusinessProductExpediterInvoiceDetailPage,
    
    ConsumerNearbyPage,
    ConsumerBusinessListPage,
    ConsumerBusinessDetailPage,
    ConsumerBusinessMainPage,
    ConsumerRedeemablesMainPage,
    ConsumerPinsPage,
    ConsumerProfilePage,
    ConsumerRewardListPage,
    ConsumerRewardDetailPage,
    ConsumerRewardBuyPage,
    ConsumerRewardSharePage,
    ConsumerPunchCardManagerPage,
    ConsumerMainPage,
    ConsumerOfferMainPage,
    ConsumerOfferManagerPage,
    ConsumerOfferListPage,
    ConsumerOfferDetailPage,
    ConsumerOfferUserListPage,
    ConsumerOfferUserDetailPage,
    ConsumerCheckoutPage,
    ConsumerPunchCardQrPage,
    ConsumerPunchCardTermsPage,
    ConsumerMessageTimelinePage,
    ConsumerMessageDetailPage,
    ConsumerProfileMainPage,
    CustomerRewardGainedPage,
    ConsumerOfferMultiStatusPage,
    ConsumerBusinessOfferListPage, 
    ConsumerBusinessPunchCardListPage, 
    ConsumerBusinessTimelinePage,
    ConsumerMoneyOrderDetailPage,
	ConsumerMoneyMainOrderListPage,
	
    ConsumerAddMoneyPage,
    ConsumerMoneyAddDevicePage,
    ConsumerProductPaymentManagerPage,
    
    PaymentMethodManagementPage,
    PaymentMethodListPage,
    PaymentMethodSelectPage,

    DefaultLoadingPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ConsumerBondHandler,
    Globals,
    AuthProvider,
    HttpHelper,
    BarcodeScanner,
    PaymentMethodHandler,
    BondManagerHandler,
    BusinessManagerHandler,
    QrCodeHandler,
        
    AppVersion,
    Camera,
    Geolocation,
    LaunchNavigator,
    //Facebook,
    InAppBrowser,
    CardIO,
    
    ConsumerBondRedeemHandlerProvider,
    BusinessRedeemHandler,
    ConsumerPointsHandlerProvider,
    ConsumerBusinessHandlerProvider,
    ConsumerHandlerProvider,
    BusinessPunchCardManagerHandler,
    BusinessPunchCardSequenceManagerHandler,
    BusinessPunchCardUserRewardManagerHandler,
    BusinessOfferManagerHandler,
    BusinessSpecialtyManagerHandler,
    BusinessUserOfferManagerHandler,
    ConsumerRewardHandlerProvider,
    ConsumerPunchCardHandler,
    ConsumerOfferManagerHandler,
    CustomSplashHandlerProvider,
    BusinessUserProvider,    
    BusinessUserInvoiceProvider,

    FormatDatePipe,
    EscapeHtmlPipe,
    Utils,
    PunchCardIconProvider,
    //OneSignal,
    PushNotificationHandlerProvider,
    BusinessMessageProvider,
    ConsumerTimelineProvider,
    ConsumerBusinessTimelineProvider,
    RichTextEditorProvider,
    BusinessDashboardProvider,
    ConsumerCheckoutHandler,
    BusinessInvoiceHandler,
    PurchaseHandlerProvider,
    ConsumerBusinessMainHandlerProvider,    
    ConsumerServiceHandlerProvider,
    CalendarHandlerProvider,
    ConsumerMoneyProvider,
    BusinessProductManagerHandler,
    BusinessProductPaymentManagerHandler,
    ConsumerMoneyDeviceProvider,
    BusinessProductInvoiceHandler,
    BusinessProductCategoryManagerHandler, 
    BusinessProductSubCategoryManagerHandler,
    ProductPaymentCheckoutHandler,
    BusinessProductSubCategoryModifierManagerHandler,
    BusinessModifierGroupManagerHandler,
    ConsumerMoneyOrderHandlerProvider,
    BusinessProductExpeditorHandlerProvider,
    ConsumerPrepayAmountManagerHandler
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts